/**
 * Renders nothing: replaces chat toolbar buttons the chat does not support.
 * "Neu erzeugen" and "Bearbeiten" would resend or rewrite a message the
 * thread already stores on the server, which the agent service refuses (the
 * conversation history comes from the API, not from the client).
 */
const HiddenControl = (): null => null

export default HiddenControl
